var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-color-picker wt2-sg"},[_c('type-' + _vm.type,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }